export default __webpack_public_path__ + "static/media/sucesspageicon.0120ba60.svg";